import { render, staticRenderFns } from "./SubsectionEdit.vue?vue&type=template&id=44281d1a&scoped=true"
import script from "./SubsectionEdit.vue?vue&type=script&lang=js"
export * from "./SubsectionEdit.vue?vue&type=script&lang=js"
import style0 from "./SubsectionEdit.vue?vue&type=style&index=0&id=44281d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44281d1a",
  null
  
)

export default component.exports